module.exports = __webpack_public_path__ + "img/carteirinhaCaoFrente_2.83aedabc.jpeg";